import React from 'react';
import Icon from '../../../components/AppIcon';


const WorkOrderSummary = ({
  workOrderNumber = '',
  vehicleData = {},
  clientData = {},
  financialSummary = {},
  currentStatus = '',
  createdDate = '',
  lastUpdate = ''
}) => {
  const statusConfig = {
    recepcionado: { label: 'Recepcionado', color: 'text-primary', bgColor: 'bg-primary/10' },
    inspeccionado: { label: 'Inspeccionado', color: 'text-accent', bgColor: 'bg-accent/10' },
    cotizando: { label: 'Cotizando', color: 'text-secondary', bgColor: 'bg-secondary/10' },
    aprobado: { label: 'Aprobado', color: 'text-success', bgColor: 'bg-success/10' },
    'en-proceso': { label: 'En Proceso', color: 'text-primary', bgColor: 'bg-primary/10' },
    terminado: { label: 'Terminado', color: 'text-success', bgColor: 'bg-success/10' },
    entregado: { label: 'Entregado', color: 'text-success', bgColor: 'bg-success/10' },
    cancelado: { label: 'Cancelado', color: 'text-error', bgColor: 'bg-error/10' }
  };

  const status = statusConfig?.[currentStatus] || statusConfig?.recepcionado;

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-2 overflow-hidden">
      <div className="bg-gradient-to-r from-primary/10 to-accent/10 p-4 md:p-6 border-b border-border">
        <div className="flex items-start justify-between gap-4 mb-3">
          <div className="flex-1 min-w-0">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground mb-1">
              {workOrderNumber}
            </h2>
            <p className="text-sm caption text-muted-foreground">
              Orden de Trabajo
            </p>
          </div>
          <div className={`px-3 py-1.5 rounded-lg ${status?.bgColor} flex-shrink-0`}>
            <span className={`text-sm font-body font-medium ${status?.color}`}>
              {status?.label}
            </span>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-3 md:gap-4 text-xs md:text-sm caption text-muted-foreground">
          <div className="flex items-center gap-1.5">
            <Icon name="Calendar" size={16} />
            <span>Creado: {createdDate}</span>
          </div>
          <span className="hidden md:inline">•</span>
          <div className="flex items-center gap-1.5">
            <Icon name="Clock" size={16} />
            <span>Actualizado: {lastUpdate}</span>
          </div>
        </div>
      </div>
      <div className="p-4 md:p-6 space-y-6">
        <div>
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-4 flex items-center gap-2">
            <Icon name="Car" size={20} className="text-primary" />
            Datos del Vehículo
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
            <div className="flex items-start gap-3 p-3 rounded-lg bg-muted/30">
              <Icon name="Hash" size={18} className="text-muted-foreground mt-0.5 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-xs caption text-muted-foreground mb-0.5">Tipo</p>
                <p className="text-sm md:text-base font-body font-medium text-foreground truncate">
                  {vehicleData?.type || 'N/A'}
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-3 rounded-lg bg-muted/30">
              <Icon name="FileText" size={18} className="text-muted-foreground mt-0.5 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-xs caption text-muted-foreground mb-0.5">Placas</p>
                <p className="text-sm md:text-base font-body font-medium text-foreground truncate">
                  {vehicleData?.plates || 'N/A'}
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-3 rounded-lg bg-muted/30">
              <Icon name="Tag" size={18} className="text-muted-foreground mt-0.5 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-xs caption text-muted-foreground mb-0.5">Marca/Modelo</p>
                <p className="text-sm md:text-base font-body font-medium text-foreground truncate">
                  {vehicleData?.brand} {vehicleData?.model}
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-3 rounded-lg bg-muted/30">
              <Icon name="Calendar" size={18} className="text-muted-foreground mt-0.5 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-xs caption text-muted-foreground mb-0.5">Año</p>
                <p className="text-sm md:text-base font-body font-medium text-foreground truncate">
                  {vehicleData?.year || 'N/A'}
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-3 rounded-lg bg-muted/30">
              <Icon name="Gauge" size={18} className="text-muted-foreground mt-0.5 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-xs caption text-muted-foreground mb-0.5">Kilometraje</p>
                <p className="text-sm md:text-base font-body font-medium text-foreground truncate">
                  {vehicleData?.mileage ? `${vehicleData?.mileage?.toLocaleString('es-MX')} km` : 'N/A'}
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-3 rounded-lg bg-muted/30">
              <Icon name="Palette" size={18} className="text-muted-foreground mt-0.5 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-xs caption text-muted-foreground mb-0.5">Color</p>
                <p className="text-sm md:text-base font-body font-medium text-foreground truncate">
                  {vehicleData?.color || 'N/A'}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-border pt-6">
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-4 flex items-center gap-2">
            <Icon name="User" size={20} className="text-secondary" />
            Datos del Cliente
          </h3>
          <div className="space-y-3">
            <div className="flex items-start gap-3 p-3 rounded-lg bg-muted/30">
              <Icon name="User" size={18} className="text-muted-foreground mt-0.5 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-xs caption text-muted-foreground mb-0.5">Nombre</p>
                <p className="text-sm md:text-base font-body font-medium text-foreground">
                  {clientData?.name || 'N/A'}
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div className="flex items-start gap-3 p-3 rounded-lg bg-muted/30">
                <Icon name="Phone" size={18} className="text-muted-foreground mt-0.5 flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="text-xs caption text-muted-foreground mb-0.5">Teléfono</p>
                  <p className="text-sm md:text-base font-body font-medium text-foreground truncate">
                    {clientData?.phone || 'N/A'}
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-3 rounded-lg bg-muted/30">
                <Icon name="Mail" size={18} className="text-muted-foreground mt-0.5 flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="text-xs caption text-muted-foreground mb-0.5">Email</p>
                  <p className="text-sm md:text-base font-body font-medium text-foreground truncate">
                    {clientData?.email || 'N/A'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* remove Resumen Financiero section */}

      </div>
    </div>
  );
};

export default WorkOrderSummary;